import './ActionButton.scss';

import React, {
    ReactNode,
    RefObject,
} from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as MenuTriggerIcon } from '../../assets/images/menu-trigger.svg';
import { ReactComponent as ArrowDetailsIcon } from '../../assets/images/arrow-details.svg';


export interface ActionMenuRef {
    hide: () => void;
    toggle: (
        event: React.MouseEvent<HTMLElement>,
        items: unknown[],
    ) => void;
}

interface ActionButtonProps {
    menuRef: RefObject<ActionMenuRef | null>;
    generateMenuItems: () => unknown[];
    showMenu?: boolean;
    showMainNavigation?: boolean;
    reserveMainNavigationSpace?: boolean;
    mainNavigateTo?: string | null;
    children?: ReactNode;
}


const ActionButton = ({
    menuRef,
    generateMenuItems,
    showMenu = true,
    showMainNavigation = true,
    reserveMainNavigationSpace = false,
    mainNavigateTo,
    children,
}: ActionButtonProps): React.ReactElement => {
    const handleMenuClick = (
        event: React.MouseEvent<HTMLDivElement>,
    ): void => {
        const menu = menuRef.current;

        if (!menu) {
            return;
        }

        menu.hide();
        menu.toggle(
            event,
            generateMenuItems(),
        );
    };

    return (
        <div className="flex gap-2 align-items-center justify-content-end w-full">
            <div>
                {children}
            </div>

            {showMenu && (
                <div
                    className="cursor-pointer flex justify-content-end align-items-center select-none"
                    style={{
                        width: '1.5rem',
                        height: '1.5rem',
                        flexShrink: 0,
                    }}
                    onClick={handleMenuClick}
                >
                    <MenuTriggerIcon />
                </div>
            )}

            {showMainNavigation && mainNavigateTo ? (
                <Link
                    to={mainNavigateTo}
                    className="arrow-icon ml-2"
                >
                    <ArrowDetailsIcon className="arrow-icon-container" />
                </Link>
            ) : reserveMainNavigationSpace ? (
                <div
                    className="arrow-icon-placeholder ml-2"
                    aria-hidden="true"
                />
            ) : null}
        </div>
    );
};


export default ActionButton;